import Left from './ChevronLeft.svg';
import Right from './ChevronRight.svg';
import ChevronRight from './ChevronLight.svg';
import Info from './Info.svg';
import InfoWhite from './InfoWhite.svg';
import InfoWhiteLarge from './InfoWhiteLarge.svg';
import Close from './Close.svg';
import Up from './ChevronUp.svg';
import Ask from './Ask.svg';
import Delete from './Delete.svg';
import Upload from './Upload.svg';
import ManageAccess from './ManageAccess.svg';
import EllipseGreen from './EllipseGreen.svg';
import EllipseYellow from './EllipseYellow.svg';
import EllipseRed from './EllipseRed.svg';
import File from './File.svg';
import Clock from './Clock.svg';
import People from './People.svg';
import Lock from './Lock.svg';
import ClosedLock from './ClosedLock.svg';
import StartArrow from './StartArrow.svg';
import SuccessAlert from './SuccessAlert.svg';
import DangerAlert from './DangerAlert.svg';
import DefaultAlert from './DefaultAlert.svg';
import WarningAlert from './WarningAlert.svg';
import ThreeDotsMenu from './ThreeDotsMenu.svg';
import NewCalendar from './NewCalendar.svg';

import ArrowLeft from './ArrowLeft.svg';
import ArrowLeftGrey from './ArrowLeftGrey.svg';
import ArrowLeftBlue from './ArrowLeftBlue.svg';
import ArrowRightGrey from './ArrowRightGrey.svg';
import AirboLogo from './AirboLogo.svg';
import Checked from './Checked.svg';
import Complete from './Complete.svg';
import CurvedArrow from './CurvedArrow.svg';
import Success from './Success.svg';
import Menu from './Menu.svg';
import MenuDotted from './MenuDotted.svg';
import BlueCircleX from './BlueCircleX.svg';
import WelcomeExpand from './WelcomeExpand.svg';
import LanguagePicker from './LanguagePicker.svg';
import Pencil from './Pencil.svg';
import Pencil2 from './Pencil2.svg';
import FinchLogo from './FinchLogo.svg';
import DoubleArrow from './DoubleArrow.svg';
import Plus from './Plus.svg';
import Xmark from './Xmark.svg';
import QuestionCircle from './Question_circle.png';
import SetupIcon from './SetupIcon.svg';
import BannerIcon from './BannerIcon.svg';
import PostsIcon from './PostsIcon.svg';
import PrizesIcon from './PrizesIcon.svg';
import UserUploadIcon from './UserUploadIcon.svg';
import ApprovalIcon from './ApprovalIcon.svg';
import ApproveCheckMark from './ApproveCheckMark.svg';
import GreenCheck from './GreenCheck.svg';
import GreenCheckWithBg from './GreenCheckWithBg.svg';
import BlackCheckWithBg from './BlackCheckWithBg.svg';
import Campaign from './Campaign.svg';
import Checkmark from './Checkmark.svg';
import Undo from './Undo.svg';
import BigTwirl from './BigTwirl.svg';
import BigTwirlBlack from './BigTwirlBlack.svg';
import Twirl from './Twirl.svg';
import PhoneFrame from './iPhone_frame.svg';
import Grid from './Grid.svg';

import './DefaultProfileIcon.png';
import './Explore.svg';
import './Clients.svg';
import './Edit.svg';
import './Prizes.svg';
import './Reports.svg';
import './Send.svg';
import './Setup.svg';
import './Users.svg';
import './Preview.svg';
import './Help.svg';

export {
  Up,
  Left,
  Right,
  Info,
  InfoWhite,
  InfoWhiteLarge,
  Close,
  ArrowLeft,
  ArrowLeftGrey,
  ArrowRightGrey,
  AirboLogo,
  Ask,
  Delete,
  Upload,
  Checked,
  ChevronRight,
  ManageAccess,
  Complete,
  Menu,
  MenuDotted,
  Clock,
  EllipseRed,
  EllipseYellow,
  EllipseGreen,
  File,
  People,
  Success,
  Lock,
  ClosedLock,
  StartArrow,
  BlueCircleX,
  WelcomeExpand,
  LanguagePicker,
  Pencil,
  Pencil2,
  SuccessAlert,
  DangerAlert,
  DefaultAlert,
  WarningAlert,
  FinchLogo,
  ThreeDotsMenu,
  DoubleArrow,
  Plus,
  Xmark,
  NewCalendar,
  QuestionCircle,
  SetupIcon,
  BannerIcon,
  PostsIcon,
  PrizesIcon,
  UserUploadIcon,
  ApprovalIcon,
  ApproveCheckMark,
  GreenCheck,
  GreenCheckWithBg,
  BlackCheckWithBg,
  ArrowLeftBlue,
  Campaign,
  Checkmark,
  Undo,
  BigTwirl,
  BigTwirlBlack,
  Twirl,
  PhoneFrame,
  Grid,
  CurvedArrow,
};
